import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

// Growth stage actions
export const actions = prepActions(service);

// Growth stage sagas
export const growthStageSagas = createController(service, actions);
